import { render, staticRenderFns } from "./WeekBtn.vue?vue&type=template&id=1836f1b3&scoped=true"
import script from "./WeekBtn.vue?vue&type=script&lang=js"
export * from "./WeekBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836f1b3",
  null
  
)

export default component.exports